"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protectedEstimateLoRaAirtime = exports.estimateLoRaAirtime = void 0;
var estimateAirtime_1 = require("./estimateAirtime");
Object.defineProperty(exports, "estimateLoRaAirtime", { enumerable: true, get: function () { return estimateAirtime_1.estimateLoRaAirtime; } });
Object.defineProperty(exports, "protectedEstimateLoRaAirtime", { enumerable: true, get: function () { return estimateAirtime_1.protectedEstimateLoRaAirtime; } });
